module.exports = __webpack_public_path__ + "img/video-detail-error.f7d224b5.png";